import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["banner", "enableButton"];
  static values = { hasReminders: Boolean };

  connect() {
    try {
      if (!("Notification" in window)) return;
      
      // Show notification banner once per browser after first interaction
      const NOTIF_SHOWN_KEY = "notificationsBannerShown";
      const shouldShowBanner = this.hasRemindersValue && Notification.permission === "default" && !localStorage.getItem(NOTIF_SHOWN_KEY);
      if (shouldShowBanner && this.hasBannerTarget) {
        this.bannerTarget.style.display = "block";
        // Mark as shown so we don't bother users again
        localStorage.setItem(NOTIF_SHOWN_KEY, "true");
      }
      
      // Listen for reminder creation events
      this.checkForNewReminders();
    } catch (_) {}
  }

  async enable() {
    try {
      if (!("Notification" in window)) return;
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        if (this.hasBannerTarget) this.bannerTarget.remove();
        this.hideBraveWarning();
        // Optionally fire a test notification
        new Notification("Notifications enabled", { body: "You will receive reminders here." });
      }
    } catch (_) {}
  }

  showBraveWarningIfNeeded() {
    // Only show after first reminder is created in this browser, never proactively on load
    const BRAVE_SHOWN_KEY = "braveWarningShownOnce";
    // Detect Brave browser
    const isBrave = (navigator.brave && navigator.brave.isBrave) || false;
    if (isBrave && Notification.permission === "default" && !localStorage.getItem(BRAVE_SHOWN_KEY)) {
      const warningElement = document.getElementById('brave-browser-warning');
      if (warningElement) {
        warningElement.style.display = 'block';
        // Only show once
        localStorage.setItem(BRAVE_SHOWN_KEY, 'true');
      }
    }
  }

  hideBraveWarning() {
    const warningElement = document.getElementById('brave-browser-warning');
    if (warningElement) {
      warningElement.style.display = 'none';
    }
  }

  // Check if user has just created their first reminder
  checkForNewReminders() {
    // Listen for form submissions in trigger forms
    document.addEventListener('submit', (event) => {
      if (event.target.querySelector('input[name="contact_trigger[interval_value]"]')) {
        // This is a reminder form submission
        setTimeout(() => {
          this.refreshNotificationState();
        }, 1000); // Wait for the form to process
      }
    });
  }

  // Refresh the notification banner state
  refreshNotificationState() {
    if (!this.hasRemindersValue && Notification.permission === "default") {
      // Check if user now has reminders by looking at the page content
      const reminderElements = document.querySelectorAll('[data-interaction-id^="trigger-"]');
      if (reminderElements.length > 0) {
        // User has created their first reminder, show notification banner
        this.element.dataset.notificationsHasRemindersValue = 'true';
        this.hasRemindersValue = true;
        
        if (this.hasBannerTarget) {
          this.bannerTarget.style.display = "block";
        }
        
        // Show Brave warning now (first reminder just created), then never again
        this.showBraveWarningIfNeeded();
      }
    }
  }
}


